import { useEffect, useRef } from "react";

const MOVE_T   = "transform 0.12s ease";
const RETURN_T = "transform 0.65s cubic-bezier(0.23, 1, 0.32, 1)";

export default function Magnetic({ children, className, style, radius = 120, strength = 0.38 }) {
  const ref = useRef(null);

  useEffect(() => {
    if (window.innerWidth < 1024) return;
    const el = ref.current;
    if (!el) return;

    const onMove = (e) => {
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = e.clientX - cx;
      const dy = e.clientY - cy;
      const dist = Math.sqrt(dx * dx + dy * dy);

      if (dist < radius) {
        el.style.transition = MOVE_T;
        el.style.transform = `translate(${dx * strength}px, ${dy * strength}px)`;
      } else {
        el.style.transition = RETURN_T;
        el.style.transform = "";
      }
    };

    const onLeave = () => {
      el.style.transition = RETURN_T;
      el.style.transform = "";
    };

    window.addEventListener("mousemove", onMove, { passive: true });
    el.addEventListener("mouseleave", onLeave);
    return () => {
      window.removeEventListener("mousemove", onMove);
      el.removeEventListener("mouseleave", onLeave);
    };
  }, [radius, strength]);

  return (
    <span ref={ref} className={className} style={{ display: "inline-block", ...style }}>
      {children}
    </span>
  );
}
